import {useTranslation} from 'react-i18next';
import {useSearchParams} from 'react-router-dom';
import {useEffect} from 'react';
import {useUnit} from 'effector-react';
import {useForm} from 'react-hook-form';
import {$appCatsSelOpts} from '../../models/applicationsModel/index.js';
import {FloatLabel} from 'primereact/floatlabel';
import {InputText} from 'primereact/inputtext';
import {MultiSelect} from 'primereact/multiselect';
import {Calendar} from 'primereact/calendar';
import {Button} from 'primereact/button';
import {Card} from 'primereact/card';

export default function Filter() {
    const {t} = useTranslation()
    const catOpts = useUnit($appCatsSelOpts)
    const statusSelOpts = [
        {value: 'in_progress', label: t('В работе')},
        {value: 'approved', label: t('Одобрена')},
        {value: 'rejected', label: t('Отклонена')},
    ]

    const {
        register,
        watch,
        setValue,
        handleSubmit,
        reset
    } = useForm({values: {bin: '', category: [], status: [], application_date_after: null, application_date_before: null}})

    const [search, setSearch] = useSearchParams()

    useEffect(() => {
        if (search && search.size > 0) {
            const parsed = {}
            search.forEach((value, key) => {
                if (parsed[key] === undefined) {
                    parsed[key] = [value]
                } else {
                    parsed[key] = [...parsed[key], value]
                }
            })

            for (const [key, val] of Object.entries(parsed)) {
                if (key === 'bin' && !!val) {
                    setValue(key, val)
                } else if ((key === 'category') && !!val) {
                    if (Array.isArray(val)) {
                        setValue(key, val.map(v => +v))
                    } else {
                        setValue(key, [+val])
                    }
                } else if (key === 'status' && !!val) {
                    if (!Array.isArray(val)) {
                        setValue(key, [val])
                    } else {
                        setValue(key, val)
                    }
                } else if (key.includes('application_date') && val && val !== 'null') {
                    setValue(key, new Date(val))
                }
            }
        }
    }, [search])

    const onSubmit = (data) => {
        for (const key in data) {
            if (!data[key] || data[key] === 'null' || (Array.isArray(data[key]) && data[key].length === 0)) {
                delete data[key]
            } else if (key.includes('application_date')) {
                data[key] = dayjs(data[key]).format('YYYY-MM-DD')
            }
        }
        setSearch(data)
    }

    const onReset = () => {
        setSearch()
        reset()
    }

    const category = watch('category')
    const status = watch('status')
    const dateFrom = watch('application_date_after')
    const dateTo = watch('application_date_before')

    return <Card title={t('Фильтр для поиска')} className={'shadow-1'}
                 pt={{content: {style: {paddingBottom: 0}}}}
    >
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={'card grid p-fluid'}>
                <div className={'col-4'}>
                    <FloatLabel>
                        <label htmlFor={'bin'} className={'font-bold block mb-2'}>{t('БИН')}</label>
                        <InputText id={'bin'} {...register('bin')} maxLength={12}/>
                    </FloatLabel>
                </div>
                <div className={'col-4'}>
                    <FloatLabel>
                        <label htmlFor={'category'} className={'font-bold block mb-2 z-1'}>{t('Категория')}</label>
                        <MultiSelect
                            value={category}
                            onChange={e => setValue('category', e.value)}
                            inputId={'category'}
                            optionLabel={'label'}
                            optionValue={'value'}
                            showClear {...register('category')}
                            options={catOpts}
                        />
                    </FloatLabel>
                </div>
                <div className={'col-4'}>
                    <FloatLabel>
                        <label htmlFor={'status'} className={'font-bold block mb-2 z-1'}>{t('Статус')}</label>
                        <MultiSelect inputId={'status'}
                                     value={status}
                                     onChange={e => setValue('status', e.value)}
                                     optionLabel={'label'}
                                     optionValue={'value'}
                                     maxSelectedLabels={1}
                                     showClear {...register('status')}
                                     options={statusSelOpts}
                        />
                    </FloatLabel>
                </div>
                <div className={'col-4 mt-3'}>
                    <FloatLabel>
                        <label htmlFor={'application_date_after'} className={'font-bold block mb-2 z-1'}>{t('Дата заявки от')}</label>
                        <Calendar inputId='application_date_after' showIcon
                                  {...register('application_date_after')}
                                  value={dateFrom}
                                  onChange={e => setValue('application_date_after', e.value)}
                                  showButtonBar
                        />
                    </FloatLabel>
                </div>
                <div className={'col-4 mt-3'}>
                    <FloatLabel>
                        <label htmlFor={'application_date_before'} className={'font-bold block mb-2 z-1'}>{t('Дата заявки до')}</label>
                        <Calendar inputId='application_date_before' showIcon
                                  {...register('application_date_before')}
                                  value={dateTo}
                                  onChange={e => setValue('application_date_before', e.value)}
                                  showButtonBar
                        />
                    </FloatLabel>
                </div>
                <div className={'col-4 mt-3'}>
                    <div className={'grid'}>
                        <div className={'col-8'}>
                            <Button type={'submit'} label={'Найти'}/>
                        </div>
                        <div className={'col-4'}>
                            <Button label={'Сбросить'} severity={'warning'} outlined onClick={onReset}/>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </Card>
}